import request from '@/utils/request'

let StatisticsApi = {
  /*订单数据统计*/
  getOrderTotal(data, errorback) {
    return request._post('/shop/statistics.sales/index', data, errorback);
  },
  /*订单时间段统计*/
  getOrderByDate(data, errorback) {
    return request._post('/shop/statistics.sales/order', data, errorback);
  },
  /*商品时间段统计*/
  getProductByDate(data, errorback) {
    return request._post('/shop/statistics.sales/product', data, errorback);
  },
  /*会员数据统计*/
  getUserTotal(data, errorback) {
    return request._post('/shop/statistics.user/index', data, errorback);
  },
   /*推广数据统计*/
   getUserTotal2(data, errorback) {
    return request._post('/shop/statistics.user/tgindex', data, errorback);
  },
  /*成交占比*/
  getUserScale(data, errorback) {
    return request._post('/shop/statistics.user/scale', data, errorback);
  },
  /*新增会员*/
  getNewUser(data, errorback) {
    return request._post('/shop/statistics.user/new_user', data, errorback);
  },
  /*新增推广用户*/
  getNewUser2(data, errorback) {
    return request._post('/shop/statistics.user/new_tguser', data, errorback);
  },
  /*成交会员数*/
  getPayUser(data, errorback) {
    return request._post('/shop/statistics.user/pay_user', data, errorback);
  },
  /*推广成交会员数*/
  getPayUser2(data, errorback) {
    return request._post('/shop/statistics.user/pay_tguser', data, errorback);
  },
  /*供应商统计*/
  getSupplierTotal(data, errorback) {
    return request._post('/shop/statistics.supplier/index', data, errorback);
  },
  /*供应商时间段统计*/
  getSupplierByDate(data, errorback) {
    return request._post('/shop/statistics.supplier/data', data, errorback);
  },
  /*访问统计*/
  getAccessTotal(data, errorback) {
    return request._post('/shop/statistics.access/index', data, errorback);
  },
  /*访问时间段统计*/
  getAccessByDate(data, errorback) {
    return request._post('/shop/statistics.access/data', data, errorback);
  },
  /*所有订单统计*/
  getAllorder(data, errorback) {
    return request._post('/shop/statistics.sales/allorder', data, errorback);
  },
  /*预交租金笔数/预交租金金额*/
  getyushou(data, errorback) {
    return request._post('/shop/statistics.sales/yushou', data, errorback);
  },
}

export default StatisticsApi;



// WEBPACK FOOTER //
// ./src/api/statistics.js